import loadModuleOnElement from "../../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = ".rebel-use-info-wrapper";

export default function loadRiverTopBar(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
